import { createRoute } from '@tanstack/react-router';
import { authenticatedRoute } from '@/router/authenticated-route';
import { requireWorkspace } from '@/router/require-workspace';
import ProgramsPage from '@/features/programs/programs-list/ProgramsPage';
import { programsQueryOptions } from '@/features/programs/programs-list/programs-query';
import {
  ProgramsSearchSchema,
  type ProgramsSearch,
} from '@/features/programs/programs-list/programs-search.schema';

export const programsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/programas',
  validateSearch: ProgramsSearchSchema,
  // App Consultor: a company/área de trabalho must be selected (from the Home)
  // before the listing is reachable — bounce to the Home otherwise (EU-374).
  beforeLoad: requireWorkspace,
  loaderDeps: ({ search }: { search: ProgramsSearch }) => search,
  loader: ({ context, deps }) => context.query.ensureQueryData(programsQueryOptions(deps)),
  component: ProgramsPage,
});
